module.exports = __webpack_public_path__ + "img/pin.f2fb300f.svg";